/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAttachmentsAvailability200,
  GetApiV1PersonIdAttachmentsAvailability401,
  GetApiV1PersonIdAttachmentsAvailability500,
  GetApiV1PersonIdAttachmentsAvailabilityPathParams,
  GetApiV1PersonIdAttachmentsAvailabilityQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsAvailability.ts";

export const getApiV1PersonIdAttachmentsAvailabilityPathParamsSchema = z.object(
  {
    id: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1PersonIdAttachmentsAvailabilityPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAttachmentsAvailability200Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAvailability200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAttachmentsAvailability401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAvailability401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAttachmentsAvailability500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAvailability500>;

export const getApiV1PersonIdAttachmentsAvailabilityQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonIdAttachmentsAvailability200Schema,
  ) as unknown as ToZod<GetApiV1PersonIdAttachmentsAvailabilityQueryResponse>;
